import { Injectable } from '@angular/core';
import { AlertController, LoadingController } from 'ionic-angular';
import { ServidorProvider } from '../providers/servidor/servidor';

var remoteServiceInstance : RemoteService;

@Injectable()
export class RemoteService {


    constructor(private alertCtrl: AlertController, private loadingController: LoadingController) {
        remoteServiceInstance = this;
    }

    public remote(methodName: string, params: any):Promise<any> {
        return new Promise(function (resolve, reject) {
            remoteServiceInstance.remoteCallSemLoading(methodName, params, function (result: any) {
                resolve(result);
            })
        })
    }
    
    
    remoteCallSemLoading(methodName: string, params: any, cb: { (result: any): void }) {
        let th = this;
        let xhr = new XMLHttpRequest();
        let url = ServidorProvider.URL_SERVIDOR_BRCOMUNIQUE +"/api/v1/rest/" + methodName;
        xhr.open('POST', url, true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.onload = function () {
            var result = JSON.parse(xhr.responseText);
            if (result['ok']) 
                cb(result['result']);
            else
                alert(result['msg']);
        };
        xhr.onerror = function() {
            th.alertCtrl.create({ title: "Sem comunicaçao com o servidor.", buttons: ["OK"] }).present();
            console.log("Sem comunicacao com o servidor ["+methodName+"] ["+JSON.stringify(params)+"]");
        }
        let pp = "";
        for (let p in params) {
            let value = params[p];
            if (value != null) {
                if (pp == "")
                    pp = p + "=" + value;
                else
                    pp = pp + "&" + p + "=" + value;
            }
        }
        xhr.send(pp);
    }

    remoteCallComLoading(methodName: string, params: any, cb: { (result: any): void }) {
        let load = remoteServiceInstance.loadingController.create({content: "Aguarde...", duration: 15000});
        load.present().then(
            () => {
                let th = this;
                let xhr = new XMLHttpRequest();
                let url = ServidorProvider.URL_SERVIDOR_BRCOMUNIQUE +"/api/v1/rest/" + methodName;
                xhr.open('POST', url, true);
                xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
                xhr.onload = function () {
                    load.dismiss();
                    var result = JSON.parse(xhr.responseText);
                    if (result['ok']) 
                        cb(result['result']);
                    else
                        alert(result['msg']);
                };
                xhr.onerror = function() {
                    load.dismiss();
                    th.alertCtrl.create({ title: "Sem comunicaçao com o servidor.", buttons: ["OK"] }).present();
                    console.log("Sem comunicacao com o servidor ["+methodName+"] ["+JSON.stringify(params)+"]");
                }
                let pp = "";
                for (let p in params) {
                    let value = params[p];
                    if (value != null) {
                        if (pp == "")
                            pp = p + "=" + value;
                        else
                            pp = pp + "&" + p + "=" + value;
                    }
                }
                xhr.send(pp);
            }
        )
    }
        
}


// WEBPACK FOOTER //
// ./src/service/RemoteService.ts